import {
  Body,
  Col,
  Illustrations,
  IllustrationType,
  Row,
  Title,
} from '@cognite/cogs.js';
import styled from 'styled-components/macro';

export const EmptyTemplate = ({
  title,
  description,
  graphic,
}: {
  title: string;
  description: string;
  // GraphicTypes not available in COGS v9; using IllustrationType instead
  graphic?: IllustrationType;
}) => {
  const renderHeader = () => (
    <StyledRowHeader>
      <Col>
        <Title level={3}>{title}</Title>
      </Col>
      <Col>
        <StyledBody level={2}>{description}</StyledBody>
      </Col>
    </StyledRowHeader>
  );

  return (
    <Container>
      {renderHeader()}
      {graphic && (
        <GraphicContainer>
          {/* Graphic missing in v9 → replaced with Illustrations */}
          <Illustrations.Solo type={graphic} />
        </GraphicContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  margin: 2rem;
  display: flex;
  flex: 1;
  overflow: auto;
  flex-direction: column;
`;

const StyledRowHeader = styled(Row)`
  margin-bottom: 2rem;
  margin-top: 0;
  padding: 0 0 1rem;
  gap: 1rem;
  border-bottom: 1px solid var(--cogs-border-default);
`;

const StyledBody = styled(Body)`
  margin-bottom: 0;
  max-width: 50rem;
`;

const GraphicContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  justify-content: center;
  align-items: center;
  min-height: 150px;
`;
